import React from 'react';
import { Text } from 'grommet';
import { formatTitleCase } from '../../util/formatters';
import { PolicyInfoProps } from './PolicyInfo';
import {
  HomeInfoGroup,
  HomeInfoLabel,
  AttemptingStringAsAddress,
  OtherInsuredLabel
} from './PolicyInfoStyles';
import { Row } from './PolicyInfoUmbrellaStyles';
import getUniqueParties from '../../util/uniqueParties/uniqueParties';

/*
Types of Commercial Products
- Umbrella
- Commercial Umbrella
- Farmowners Umbrella
- Commercial Package
*/
export default ({
  information,
  accountNumber,
  policyNumber
}: PolicyInfoProps) => {
  const insuredAssets = information?.insuredassets?.items ?? [];
  const insuredParties = information?.insuredparties?.items ?? [];
  const uniqueParties = getUniqueParties(information?.insuredparties?.items);
  let i = 0;
  const assetList: (string | null)[] = [];
  const uniqueLocations = [];
    for (i = 0; i < insuredAssets.length; i += 1) {
      const current = insuredAssets[i];
      if (
        current?.asset &&
        current?.asset_name?.toUpperCase().includes('LOCATION')
      ) {
        if (!assetList.includes(current.asset)) {
          assetList.push(current.asset);
          uniqueLocations.push(current);
        }
      }
    }
  return (
    <Row>
      {uniqueLocations.map(item => (
        <div>
          {item.asset_name !== null &&
            item.asset_name.toUpperCase().includes('LOCATION') &&
            item.asset !== null && (
              <HomeInfoGroup>
                <HomeInfoLabel>Address</HomeInfoLabel>
                <AttemptingStringAsAddress>
                  {item.asset}
                </AttemptingStringAsAddress>
              </HomeInfoGroup>
            )}
        </div>
      ))}
      {insuredParties?.length > 0 && (
        <HomeInfoGroup>
          <OtherInsuredLabel>Other Insured</OtherInsuredLabel>
          {uniqueParties.map(item => (
            <Text wordBreak="keep-all" size="16px">
              {formatTitleCase(item)}
            </Text>
          ))}
        </HomeInfoGroup>
      )}
    </Row>
  );
};
